import { Component } from '@theme/component';

/**
 * Compra por género (blocks/gender-filter.liquid).
 *
 * Cada botón añade o quita su etiqueta del parámetro `filter.p.tag` de la URL actual, de modo
 * que se combina con los filtros ya aplicados y con el orden, y pide al componente de filtros del
 * tema que vuelva a renderizar la sección sin recargar la página. Sin ese componente en la
 * página, el enlace del botón navega de forma normal.
 *
 * El estado activo lo pinta Liquid al re-renderizar la sección, que incluye este bloque.
 */
class GenderFilter extends Component {
  /**
   * Aplica o quita la etiqueta del botón pulsado.
   * @param {MouseEvent} event
   */
  toggle(event) {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-tag]');
    if (!(button instanceof HTMLElement)) return;

    const facets = document.querySelector('facets-form-component');
    if (!facets || typeof (/** @type {any} */ (facets).updateFiltersByURL) !== 'function') return;

    event.preventDefault();

    const tag = button.dataset.tag ?? '';
    const value = button.dataset.value ?? tag;
    const isActive = button.getAttribute('aria-pressed') === 'true';
    const matches = new Set([tag.toLowerCase(), value.toLowerCase()]);

    const url = new URL(window.location.href);
    const current = url.searchParams.getAll('filter.p.tag');
    url.searchParams.delete('filter.p.tag');

    for (const entry of current) {
      if (!matches.has(entry.toLowerCase())) url.searchParams.append('filter.p.tag', entry);
    }
    if (!isActive) url.searchParams.append('filter.p.tag', value);

    url.searchParams.delete('page');

    button.setAttribute('aria-pressed', String(!isActive));
    /** @type {any} */ (facets).updateFiltersByURL(`${url.pathname}${url.search}`);
  }
}

if (!customElements.get('gender-filter')) {
  customElements.define('gender-filter', GenderFilter);
}
